module.exports = __webpack_public_path__ + "static/media/сut_some_wood1.b7bf89db.png";